import { HeroSection } from "../components/homepage/HeroSection";
import { SalesSection } from "../components/homepage/SalesSection";
import { CategoriesSection } from "../components/homepage/CategoriesSection";
import { BestProducts } from "../components/homepage/BestProducts";
import { BoomboxSection } from "../components/homepage/BoomboxSection";
import { ExploreSection } from "../components/homepage/ExploreSection";
import { NewArrivalSection } from "../components/homepage/NewArrivalSection";
import { FeaturesSection } from "../components/homepage/FeaturesSection";

export function Homepage() {
    return (
        <div className="homepage overflow-hidden">

            <HeroSection />

            <div className="mx-auto main-wrapper mb-5">
                <SalesSection />
                <CategoriesSection />
                <BestProducts />
                <BoomboxSection />
                <ExploreSection />
                <NewArrivalSection />
                <FeaturesSection />
                <div
                    className="home-arrow-up scroll-arrows lg-on position-relative start-100 mt-5"
                    onClick={() => window.scrollTo(0, 0)}>
                </div>
            </div>

        </div>
    )
}